import { AvatarBlock, Link } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { hasOneAuthorization } from '@frontend/utils';
import type { IOrganization } from '../../interfaces/organization';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';

export interface IOrganizationProfileProps {
    hideTxcsId?: boolean;
    linkToOrganizationPage?: boolean;
    organizationId: string;
    size: 'large' | 'small';
}
export function OrganizationProfile(props: IOrganizationProfileProps) {
    const abortableFetch = useAbortableFetch();
    const [organization, setOrganization] = useState<IOrganization>();

    const canReadTxcsId = hasOneAuthorization(ManagerAuthorization.organizationRead) && !props.hideTxcsId;

    useEffect(() => {
        loadOrganization(props.organizationId);
    }, [props.organizationId]);

    if (!organization) {
        return null;
    }

    return (
        <AvatarBlock
            backgroundColor="white"
            icon="organization"
            shape="square"
            size={props.size}
            title={
                props.linkToOrganizationPage ? (
                    <Link
                        color="subtle"
                        textAlign={props.size === 'large' ? 'center' : undefined}
                        to={`/organizations/${props.organizationId}/view`}
                        variant="link"
                    >
                        {organization.name}
                    </Link>
                ) : (
                    organization.name
                )
            }
            titleSuffix={canReadTxcsId && organization.txcsId ? ` - ${organization.txcsId}` : undefined}
        />
    );

    async function loadOrganization(organizationId: string) {
        const url = `/api/organizations/${organizationId}`;
        const result = await abortableFetch.fetchJson(url, 'GET');

        setOrganization(result.json);
    }
}
